export default{
	state:{
		showImgSelect:false,
		success_fn:()=>{},
		mult:3,
		type_nav:"图片",
		select_type:"图片"
	},
	mutations:{
		change_show_select_img(state){
			state.showImgSelect = !state.showImgSelect
		},
		change_type_nav(state,type){
			state.type_nav = type;
		},
		selectimgSuccess(state,e){
			if(state.select_type != e.type){
				window.vuevm.$message({
					type:'info',
					message:'当前位置只支持添加'+state.select_type+"素材"
				})
				return 
			}
			state.showImgSelect = false;
			if(state.success_fn){
				state.success_fn(e.list)
			}
		},
		select_img(state,fn){
			state.mult = fn.mult || true;
			state.success_fn = fn.success;
			state.select_type = fn.type || "图片";
			state.type_nav = fn.type || "图片";
			state.showImgSelect = true;
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/modules/media.js